import Swiper, { A11y, Autoplay, Navigation, Pagination, EffectFade } from 'swiper';
import { getDataProperty } from '../utils/_domFunctions';

class mCarrousel extends HTMLDivElement {
    constructor() {
        super();
        this.slider = null;
        this.sliderInitialised = false;
        this.autoplayDelay = undefined;
    }

    connectedCallback() {
        this.autoplayDelay = getDataProperty(this, 'autoplayDelay', 'number', undefined);

        if (this.classList.contains('auto-init') && !this.sliderInitialised) {
            this.initSlider(); // init slider on pageload on mobile
        }
    }

    initSlider() {
        if (!this.sliderInitialised) {
            const autoplayOptions = {
                delay: this.autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            };

            var isTopBanner = this.closest('[is="m-header-banner"');

            this.slider = new Swiper(this, {
                modules: [A11y, Autoplay, Navigation, Pagination, EffectFade],
                initialSlide: 0,
                loop: !!isTopBanner,
                allowTouchMove: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                fadeEffect: { crossFade: true },
                effect: this.dataset.fade === 'true' ? 'fade' : 'coverflow',
                a11y: {
                    prevSlideMessage: this.dataset.a11ySlidePrev,
                    nextSlideMessage: this.dataset.a11ySlideNext
                },
                pagination: isTopBanner ? {} : {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                preventInteractionOnTransition: !isTopBanner,
                autoplay: this.autoplayDelay ? autoplayOptions : false
            });

            this.sliderInitialised = true;
        }
    }
}

customElements.define('m-carrousel', mCarrousel, {
    extends: 'div'
});
